<template>
<div class='vx-row w-full container'>
    <div class="w-full ancho-minimo-1 alto-pizarra">
        <div class="cabecera-1 mb-4 text inline flex">
            <vs-button class="m-1" color="warning" icon="refresh" @click="f_reiniciar()">Reiniciar</vs-button>
            <vs-button class="m-1" v-if="juego_resultados==0" color="success" icon="bolt" @click="juego_resultados=1">Resultados ( {{ respuestas_pares.length }} ) </vs-button>
            <vs-button class="m-1" v-if="juego_resultados==1" color="success" icon="reply_all" @click="juego_resultados=0">Volver</vs-button>
        </div>
        <vs-alert v-if="datos_editar.estado == 0" color="danger">{{ txt_juego_inactivo }} </vs-alert>
        <div class="container emparejar-game bg-emparejar m-2 p-4 bg-success">
            <div class="vx-row">
                <vs-col class="w-4/5">
                    <div class="datos-juego-cabecera">
                        <div>
                            <h3 class="titulo-juego"> {{ datos_juego.titulo }}</h3>
                            <h5 class="text-white subtitulo-juego"> {{ datos_juego.descripcion }} </h5>
                        </div>
                        <div class="ancho-auto p-2 inline-block">
                            <Voces :datosVoz="datosVoz" />
                        </div>
                        <div class="ancho-auto p-2 inline-block" v-if="conReloj">
                            <Reloj :conReloj="conReloj" :game_fin="game_fin" />
                        </div>
                    </div>
                </vs-col>
                <vs-col class="w-1/5">
                    <div class="calificacion text-color-2">
                        <transition name="bounce">
                            <div v-if="datos_juego.correctas>0">
                                {{datos_juego.correctas.toFixed(2)}} &nbsp;
                            </div>
                            <div v-else> 0 &nbsp; </div>
                        </transition>/ {{ datos_juego.puntaje }}
                    </div>
                </vs-col>
            </div>

            <section>
                <transition name="fade">
                    <div v-if="juego_resultados==0">
                        <div class="slider mt-4 mx-auto">
                            <div class="botones text-center mt-2">
                                <button id="prev" @click="f_op_uno_prev()">
                                    <feather-icon icon="ChevronLeftIcon" svgClasses="h-4 w-4" class="ml-1" />
                                </button>
                                <button id="next" @click="f_op_uno_next()">
                                    <feather-icon icon="ChevronRightIcon" svgClasses="h-4 w-4" class="ml-1" />
                                </button>
                            </div>
                            <div class="mt-4">
                                <transition name="slide" class="mx-auto text-center">
                                    <h1 class="text text-center" :id="seleccionadoA.id" v-if="showDiv1">{{ seleccionadoA.texto }}</h1>
                                </transition>
                                <transition name="slide" class="mx-auto text-center ">
                                    <h2 v-if="arrayPreguntas.length==0" class="textoFin centrado mt-4">{{texto_finalizado}}</h2>
                                </transition>
                            </div>
                        </div>
                        <div>
                            <div class="mt-4 mb-4 centrado text-center">
                                <button class="btn-asociar inline-block" :class="{'btn-circulo' : btn_circulo}" color="warning" :disabled="!showUnion" @click="f_union()">
                                    <span v-if="!btn_circulo">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrows-down-up" width="25" height="25" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M17 3l0 18" />
                                            <path d="M10 18l-3 3l-3 -3" />
                                            <path d="M7 21l0 -18" />
                                            <path d="M20 6l-3 -3l-3 3" />
                                        </svg>

                                        Asociar</span>
                                    <span v-if="btn_circulo">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-link" width="25" height="25" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M9 15l6 -6" />
                                            <path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" />
                                            <path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div class="sliderB mt-4">
                            <div class="botones text-center mt-2">
                                <button id="prevC" @click="f_op_dos_prev()">
                                    <feather-icon icon="ChevronLeftIcon" svgClasses="h-4 w-4" class="ml-1" />
                                </button>
                                <button id="nextC" @click="f_op_dos_next()">
                                    <feather-icon icon="ChevronRightIcon" svgClasses="h-4 w-4" class="ml-1" />
                                </button>
                            </div>
                            <div class="mt-4">
                                <transition name="slide" class="mx-auto text-center">
                                    <h4 class="texto text-center" :id="seleccionadoB.id" v-if="showDiv2">{{ seleccionadoB.texto }}</h4>
                                </transition>
                            </div>
                        </div>
                        <div class="pendientes text-white">
                            Faltan: {{ arrayPreguntas.length  }}
                        </div>
                    </div>
                </transition>
            </section>

            <!-- ***********************RESULTADOS*********************** -->
            <section>
                <transition name="fade">
                    <div v-if="juego_resultados==1" class="w-full mt-4">
                        <div class="borde-2 container bg-respuestas mt-2">
                            <div class=" w-full mt-2">
                                <vs-row class="w-full mt-3 text-dark m-4">
                                    <vs-col vs-w="5"><b>Pregunta</b></vs-col>
                                    <vs-col vs-w="5"><b>Respuesta</b></vs-col>
                                    <vs-col vs-w="2"> </vs-col>
                                </vs-row>
                                <vs-row class="w-full mt-3 m-4" v-for="(item, index) in respuestas_pares" :key="index">
                                    <vs-col class="p-4" :class="item.res_correcta===1 ? 'bg-ok' : 'bg-incorrecta text-dark'" vs-w="5">{{ item.pregunta.texto}}</vs-col>
                                    <vs-col class="p-4" :class="item.res_correcta===1 ? 'bg-ok' : 'bg-incorrecta text-dark'" vs-w="5"> {{ item.respuesta.texto }} </vs-col>
                                    <vs-col vs-w="2" class="text-center">
                                        <vs-button v-if="item.res_correcta===1" icon-pack="feather" icon="icon-check" color="success"></vs-button>
                                        <vs-button v-else icon-pack="feather" icon="icon-x"></vs-button>
                                        <!-- <vs-button v-else icon-pack="feather" icon="icon-arrow-left" @click="f_regresar_respuesta(item,index)"></vs-button> -->
                                    </vs-col>
                                </vs-row>
                            </div>
                        </div>
                    </div>
                </transition>
            </section>
        </div>
    </div>

</div>
</template>

<script>
import GeneralMixin from '@/mixins/GeneralMixin';
import Voces from '../componentes/voces.vue';
import Reloj from '../componentes/reloj.vue';
export default {
    mixins: [GeneralMixin],
    props: {
        datos_editar: {
            type: Object,
            default: function () {
                return {};
            },
        },
        juego_seleccionado: {
            type: Object,
            default: function () {
                return {};
            },
        }
    },
    components: {
        Voces,
        Reloj
    },
    data() {
        return {
            modalResultados: false,
            arrayPreguntas: [],
            arrayRespuestas: [],
            active: 0,
            activeB: 0,
            selectA: '',
            selectB: '',
            seleccionadoA: {},
            seleccionadoB: {},
            showDiv2: false,
            showDiv1: false,
            showUnion: true,
            tiempo: 500,
            tiempo2: 1000,
            respuestas_pares: [],
            show_correcta: false,
            datos_juego: {},
            texto_finalizado: 'Finalizado',
            juego_resultados: 0,
            datosVoz: {},
            conReloj: false,
            game_fin: false,
            btn_circulo: false,
            txt_juego_inactivo: 'Juego inactivo - no será visible para el estudiante',
        };
    },
    created() {},
    mounted() {
        let me = this;
        const game_select = Object.keys(me.juego_seleccionado).length == 0
        // console.log('game select', game_select,me.juego_seleccionado)
        if (game_select) {
            this.f_inicio();
        } else {
            me.f_obtener_datos_juego();
        }
    },
    methods: {
        f_obtener_datos_juego() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'get_juego_by_codigo/' + me.juego_seleccionado.codigo)
                .then(function (response) {
                    // console.log(response.data);
                    me.datos_editar = response.data[0];
                    me.f_inicio();
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.f_notificaciones("No se encontró el juego.", "danger");
                    me.$vs.loading.close();
                    // me.$vs.loading.close();
                })
        },
        f_reiniciar() {
            let me = this;
            me.respuestas_pares=[];
            me.f_inicio();
        },
        f_inicio() {
            let me = this;
            me.datosVoz = me.datos_editar
            me.id_juego = me.datos_editar.id;
            // console.log('datos editar en previsualizar', me.datos_editar, me.id_juego)
            if (me.datos_editar.tiempo == 1) me.conReloj = true;
            me.datos_juego = {
                puntaje: me.datos_editar.puntaje,
                correctas: 0,
                division_puntaje: 0,
                titulo: me.datos_editar.nombre,
                descripcion: me.datos_editar.descripcion
            }
            me.f_get_opciones_juego();
        },
        f_rellenar_datos() {
            let me = this;
            me.datos_juego.division_puntaje = me.datos_juego.puntaje / me.arrayPreguntas.length
            me.arrayPreguntas.sort(() => (Math.random() > 0.5) ? 1 : -1)
            me.arrayRespuestas.sort(() => (Math.random() > 0.5) ? 1 : -1)
            me.active = 0;
            me.activeB = 0;
            me.f_uno();
            me.f_dos();
        },
        f_uno() {
            let me = this;
            if (me.arrayPreguntas.length == 0) {
                me.juego_resultados = 1;
                me.game_fin = true;
                return; //si el array esta vacio
            }
            setTimeout(() => {
                me.seleccionadoA = me.arrayPreguntas[me.active];
                // me.showUnion = false;
                me.showDiv1 = true;
            }, me.tiempo);
        },
        f_dos() {
            let me = this;
            if (me.arrayRespuestas.length == 0) {
                return //si el array respuestas esta vacio
            }
            me.seleccionadoB = me.arrayRespuestas[me.activeB];
            // console.log('seleccionadoB',me.seleccionadoB.texto,me.active)
            setTimeout(() => {
                me.showDiv2 = true;
            }, me.tiempo);
        },
        f_op_uno_next() {
            let me = this;
            me.active = me.active + 1 < me.arrayPreguntas.length ? me.active + 1 : me.active = 0;
            me.showDiv1 = false;
            // me.f_sin_opciones(me.arrayPreguntas)
            setTimeout(() => {
                me.f_uno();
            }, me.tiempo);
        },
        f_op_uno_prev() {
            let me = this;
            me.active = me.active - 1 >= 0 ? me.active - 1 : me.active = me.arrayPreguntas.length - 1;
            me.showDiv1 = false;
            // me.f_sin_opciones(me.arrayPreguntas)
            setTimeout(() => {
                me.f_uno();
            }, me.tiempo);
        },
        f_op_dos_next() {
            let me = this;
            me.activeB = me.activeB + 1 < me.arrayRespuestas.length ? me.activeB + 1 : me.activeB = 0;
            me.showDiv2 = false;
            // me.f_sin_opciones(me.arrayRespuestas)
            setTimeout(() => {
                me.f_dos();
            }, me.tiempo);
        },
        f_op_dos_prev() {
            let me = this;
            me.activeB = me.activeB - 1 >= 0 ? me.activeB - 1 : me.arrayRespuestas.length - 1;
            me.showDiv2 = false;
            // me.f_sin_opciones(me.arrayRespuestas)
            setTimeout(() => {
                me.f_dos();
            }, me.tiempo);
        },

        f_union() {
            let me = this;
            me.showUnion = true;
            if (me.arrayPreguntas.length == 0) {
                return; //si el array esta vacio
            }
            me.showUnion = false;
            me.btn_circulo = true;
            setTimeout(() => {
                me.f_acciones_union();
            }, me.tiempo2);
        },
        f_acciones_union() {
            let me = this;
            me.show_correcta = false;
            let resA, resB, t1, t2, correcta = 0;
            // resA = me.seleccionadoA.id.substring(1);
            // resB = me.seleccionadoB.id.substring(1);
            resA = me.seleccionadoA.id;
            resB = me.seleccionadoB.id;
            t1 = me.seleccionadoA.id;
            t2 = me.seleccionadoB.id;
            if (resA == resB) {
                correcta = 1;
                me.datos_juego.correctas += parseFloat(me.datos_juego.division_puntaje.toFixed(2));
                // console.log('correctas', me.datos_juego.correctas)
                setTimeout(() => {
                    me.show_correcta = true;
                }, me.tiempo);
            }
            setTimeout(() => {
                me.showUnion = true;
                me.btn_circulo = false;
            }, me.tiempo);
            me.respuestas_pares.push({
                id: resA,
                pregunta: me.seleccionadoA,
                respuesta: me.seleccionadoB,
                resA: resA,
                resB: resB,
                t1: t1,
                t2: t2,
                res_correcta: correcta
            });
            // console.log(me.respuestas_pares);
            let preguntaA = me.arrayPreguntas.findIndex(pregunta => pregunta.id === t1);
            let preguntaB = me.arrayRespuestas.findIndex(pregunta => pregunta.id === t2);
            me.arrayPreguntas.splice(preguntaA, 1);
            me.arrayRespuestas.splice(preguntaB, 1);
            me.f_op_uno_next();
            me.f_op_uno_prev();
            me.f_op_dos_next();
            me.f_op_dos_prev();
            // if (resA == resB) {}
        },
        f_regresar_respuesta(item, index) {
            let me = this;
            // console.log(item.id, index)
            let get_index_array_pregunta = me.respuestas_pares.find(pregunta => pregunta.id === item.id);
            me.arrayPreguntas.push(get_index_array_pregunta.pregunta);
            let get_index_array_respuesta = me.respuestas_pares.find(pregunta => pregunta.id === item.id);
            me.arrayRespuestas.push(get_index_array_respuesta.respuesta);
            me.respuestas_pares.splice(index, 1)
            // console.log(me.arrayPreguntas.length)
            if (me.arrayPreguntas.length == 1) {
                me.f_op_uno_next();
                me.f_op_dos_next();
            }
        },
        f_get_opciones_juego() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url + 'get_opciones_emparejar/' + me.id_juego)
                .then(function (response) {
                    // console.log(response.data);
                    me.arregloOpciones = response.data;
                    me.f_separar_preguntas_respuestas()
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.f_notificaciones("No se logró obtener las respuestas del juego")
                    me.$vs.loading.close();
                });
        },
        f_separar_preguntas_respuestas() {
            let me = this;
            me.arrayPreguntas = me.arregloOpciones.map(obj => ({
                id: obj.id,
                texto: obj.pregunta
            }));
            me.arrayRespuestas = me.arregloOpciones.map(obj => ({
                id: obj.id,
                texto: obj.respuesta
            }));
            me.f_rellenar_datos();
        }
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Seymour+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Chocolate+Classical+Sans&family=LXGW+WenKai+Mono+TC&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&family=Teko:wght@300..700&display=swap');

.centrado {
    display: flex;
    justify-content: center;
}

.cabecera-1 {
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
    margin-right: 0;
}

.pizarra {
    padding: 20px;
    /* background: rgb(19, 71, 49); */
    background: radial-gradient(circle, rgba(19, 71, 49, 1) 0%, rgb(42, 102, 76) 100%);
    border-width: 15px;
    border-style: solid;
    border-image: linear-gradient(to right, rgb(216, 148, 77), rgb(177, 121, 62)) 1;


}

.texto {
    color: #0e250f;
}

.slider,
.sliderB {
    /* position: relative; */
    /* margin-top: 100px; */
    width: 100%;
    height: 15em;
    overflow: hidden;
    background-color: rgba(228, 245, 227, 0.8);
    /* background-color: #e4f5e3; */

    border: solid 1px #66b964;
    /*  */

}

.link {
    margin: auto;

}

.slider {
    /* background-color: aqua; */
    border-radius: 30px 30px 0 0;
}

.sliderB {
    /* background-color: rgb(116, 223, 95); */
    border-radius: 0 0 30px 30px;
}

.item,
.itemB {
    text-align: center;
    left: 15%;
    width: 70%;
    height: auto;
    /* position: absolute; */
    border-radius: 10px;
    padding: 0 20px;
    transition: 0.5s;
    color: black;
    margin-top: 28px;
    /* background-color: #f0ecec; */
}

.item {
    top: 15%;
    font-size: 1.8em;
    font-weight: 600;
}

.itemB {
    top: 65%;
    /* background-color: #d68989; */
    font-size: 1.3em;
    font-weight: 500;
}

#next,
#nextC {
    /* position: absolute; */
    right: 50px;
    top: 40%;
}

#prev,
#prevC {
    /* position: absolute; */
    left: 50px;
    top: 40%;
}

#prev,
#next,
#prevC,
#nextC {
    background-color: #61a35e;
    color: #fff;
    border: none;
    /* font-size: 45px; */
    font-family: monospace;
    font-weight: bold;
    opacity: 0.8;
    transition: opacity 0.5s;
    width: 40px;
    height: 35px;
    margin: 0 4px;
}

#prev:hover,
#next:hover,
#prevC:hover,
#nextC:hover {
    opacity: 1;
    cursor: pointer;
}

.slide-leave-active,
.slide-enter-active {
    transition: 0.2s;
}

.slide-enter {
    transform: translate(50%, 0);
    filter: blur(8px);
    -webkit-filter: blur(8px);
}

.slide-leave-to {
    transform: translate(-50%, 0);
}

.bg-ok {
    /* background-color: #082b10; */
    border: solid 2px #082b10;
    /* background: radial-gradient(circle, rgba(19, 71, 49, 1) 0%, rgb(42, 102, 76) 100%); */

    /* color: #f1fcf2; */
    font-weight: bolder;
    border-radius: 15px
}

.bg-incorrecta {
    /* background-color: #082b10; */
    border-bottom: solid 3px #a71111;
    /* background: radial-gradient(circle, rgba(19, 71, 49, 1) 0%, rgb(42, 102, 76) 100%); */

    /* color: #f1fcf2; */
    font-weight: bolder;
    border-radius: 15px
}

.textoFin {
    color: #03301f;
    margin-top: 15px;
    font-family: "Seymour One", cursive;
    font-size: 2.5em;
    letter-spacing: 20px;
}

.bg-filas {
    background-color: beige;
}

.titulo-juego {
    /* font-family: "Teko", sans-serif; */
    color: white;
    font-optical-sizing: auto;
    font-weight: 400;
    font-style: normal;
    font-size: 2.5em;
    font-family: "LXGW WenKai Mono TC", monospace;
}

.subtitulo-juego {
    font-family: "LXGW WenKai Mono TC", monospace;
    font-optical-sizing: auto;
}

.datos-juego-cabecera {
    background-color: #295328;
    padding: 15px;
    border-radius: 0 15px 15px 0;
}

.borde-2 {
    border: 2px solid #aabb9f;
}

.text-color-2 {
    color: #224522;
}

.bg-emparejar {
    background-image: url('./assets/bg-emparejar.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom center;
    min-height: 700px;
    /* border-image: linear-gradient(to right, rgb(216, 148, 77), rgb(177, 121, 62)) 1; */
    border-width: 15px;
    border-style: solid;
    border-image: linear-gradient(to right, rgb(216, 148, 77), rgb(255, 162, 62)) 1;
}

.btn-asociar {
    width: 180px;
    height: 50px;
    padding: 10px;
    background-color: orangered;
    color: white;
    font-size: 1.5em;
    border: none;
    border-radius: 6px;
    transition: .3s;
    cursor: pointer;
    animation: animar_boton 1s infinite;
}

@keyframes animar_boton {
    0% {
        scale: 1;
    }

    80% {
        scale: 1.1
    }

    100% {
        scale: 1
    }
}

.btn-asociar:hover {
    scale: 1.2;
}

.btn-circulo {
    width: 50px;
    height: 50px;
    background: orangered;
    border-radius: 50%;
    transform: rotate(-360deg);
    cursor: wait;
    box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
}

.bg-respuestas {
    background-color: rgb(241, 252, 242, 0.7)
}

.alto-pizarra {
    min-height: 550px;
}

@media screen and (max-width: 700px) {

    .pizarra {
        padding: 10px;
        /* background: rgb(19, 71, 49); */
        background: radial-gradient(circle, rgba(19, 71, 49, 1) 0%, rgb(42, 102, 76) 100%);
        border-width: 10px;
        border-style: solid;
        border-image: linear-gradient(to right, rgb(216, 148, 77), rgb(177, 121, 62)) 1;

    }

    .textoFin {
        color: rgb(207, 231, 191);
        margin-top: 15px;
        font-family: "Seymour One", cursive;
        font-size: 2em;
        letter-spacing: 10px;
    }

    .titulo-juego {
        color: white;
        font-optical-sizing: auto;
        font-weight: 400;
        font-style: normal;
        font-size: 1.6em;
        /* margin-right: 15%; */
        font-family: "LXGW WenKai Mono TC", monospace;
    }

    .subtitulo-juego {
        /* background-color: red; */
        font-family: "LXGW WenKai Mono TC", monospace;
        font-optical-sizing: auto;
        /* margin-right: 15%; */
    }
}

@media screen and (max-width: 500px) {

    .datos-juego-cabecera {
        background-color: rgb(218, 231, 214, 0.3);
        padding: 8px;
        border-radius: 0 15px 15px 0;
    }
}
</style>
